module.exports = __webpack_public_path__ + "media/customizations/mayfairtxlife/logo-new-91f816e0169703ae452f99a0dc0a98e8.png";